import React from 'react';
import { Button } from './ui/Button';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
export function HeroSection() {
  const {
    ref,
    isVisible
  } = useScrollAnimation();
  const scrollToOffer = () => {
    document.getElementById('offer-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-24 pb-16 md:pt-32 md:pb-24 px-4 overflow-hidden bg-cream" data-id="element-69">
      <div ref={ref} className={`max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-70">
        <div className="space-y-8 text-center lg:text-left z-10" data-id="element-71">
          <div className="inline-block px-4 py-1.5 rounded-full bg-sage text-teal text-sm font-semibold tracking-wider uppercase mb-2" data-id="element-72">
            Protocolo de Emergencia
          </div>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-teal leading-tight" data-id="element-73">
            El Reinicio de <span className="text-gold italic" data-id="element-74">72 Horas</span>
          </h1>
          <p className="text-lg md:text-xl text-charcoal leading-relaxed max-w-2xl mx-auto lg:mx-0" data-id="element-75">
            Recupera tu energía y detén el colapso emocional en solo 3 días, sin
            abandonar tus responsabilidades ni necesitar un retiro de lujo.
          </p>
          <div className="pt-4" data-id="element-76">
            <Button href="https://www.digilecto.com/cart/51078003097878:1" subtext="Comienza tu recuperación en 3 días" className="w-full sm:w-auto" data-id="element-77">
              SÍ, NECESITO ESTE REINICIO AHORA
            </Button>
          </div>
        </div>

        <div className="relative z-10 mt-8 lg:mt-0" data-id="element-78">
          <div className="absolute inset-0 bg-gold/20 rounded-full blur-3xl transform scale-90 -z-10" data-id="element-79"></div>
          <img src="https://cdn.magicpatterns.com/uploads/4k6NbtGSWaJJkT2N1YyWcX/heylloyd-image-1772661390163.png" alt="El Reinicio de 72 Horas - Guía para Recuperar tu Energía" className="w-full h-auto object-contain drop-shadow-2xl rounded-2xl" data-id="element-80" />
        </div>
      </div>
    </section>;
}